import Button from '~/src/components/mui-wrappers/buttons/Button'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import EditIcon from '@mui/icons-material/Edit'
import { useEoValue } from '~/src/hooks/useEoState'
import { LAYOUT_STATE } from '~/src/stores/layout'
import DeliveryMethodsSummaryMethodSentence
  from '~/src/components/delivery-methods/delivery-methods-summary/delivery-methods-summary-method/delivery-methods-summary-method-sentence'

interface Props {
  showAnimation: boolean,
}

const DeliveryMethodsSummaryMethod = ({ showAnimation }: Props) => {
  const { isMobile } = useEoValue(LAYOUT_STATE)

  return (
    <Button
      className='delivery-methods-summary__button'
      variant={'contained'}
      fullWidth
      sx={{
        justifyContent: 'space-between',
        textTransform: 'none',
        borderRadius: 1
      }}
      endIcon={isMobile ? <KeyboardArrowDownIcon/> : <EditIcon/>}>
      <DeliveryMethodsSummaryMethodSentence showAnimation={showAnimation}/>
    </Button>
  )
}

export default DeliveryMethodsSummaryMethod
